import request from './utils/request'

/**
 * 普通渠道-业务办理统计
 */
export function getBusinessHandlingStatistics() {
  return request({
    url: '/web/workbench/normalChannelDataStatistics/businessHandlingStatistics',
    method: 'get'
  })
}

/**
 * 普通渠道-业务办理增长趋势
 * @param {{ analyzeType: 'year'|'quarter'|'month', analyzeYear?: string }} params
 */
export function getBusinessHandlingGrowthTrend(params) {
  return request({
    url: '/web/workbench/normalChannelDataStatistics/businessHandlingGrowthTrend',
    method: 'get',
    params
  })
}

/**
 * 普通渠道-用户统计与用户服务转化
 */
export function getUserStatistics() {
  return request({
    url: '/web/workbench/normalChannelDataStatistics/userStatistics',
    method: 'get'
  })
}

/**
 * 普通渠道-用户增长趋势
 * @param {{ analyzeType: 'year'|'quarter'|'month', analyzeYear?: string }} params
 */
export function getUserGrowthTrend(params) {
  return request({
    url: '/web/workbench/normalChannelDataStatistics/userGrowthTrend',
    method: 'get',
    params
  })
}

/**
 * 普通渠道-作品类型分布
 */
export function getWorkTypeDistribution() {
  return request({
    url: '/web/workbench/normalChannelDataStatistics/workTypeDistribution',
    method: 'get'
  })
}

/**
 * 普通渠道-用户业务办理榜单
 */
export function getUserBusinessHandlingRanking() {
  return request({
    url: '/web/workbench/normalChannelDataStatistics/userBusinessHandlingRanking',
    method: 'get'
  })
}
